import { cn } from "@/lib/utils";
import { createLink, LinkComponent } from "@vixi/router";
import { ComponentProps, forwardRef } from "react";

interface TextLinkProps extends ComponentProps<"a"> {
  color?: "primary";
  underline?: "hover" | "always" | "none";
  disabled?: boolean;
}

const StyledTextLink = forwardRef<HTMLAnchorElement, TextLinkProps>(
  ({ underline, disabled, ...props }, ref) => {
    return (
      <a
        {...props}
        className={cn(
          "text-primary hover:text-primary-dark ar:font-medium cursor-pointer font-semibold transition-colors duration-200",
          {
            underline: underline === "always",
            "hover:underline": underline === "hover",
            "cursor-not-allowed opacity-60": disabled,
          },
          props.className,
        )}
        ref={ref}
      />
    );
  },
);

interface StyledTextLinkProps extends ComponentProps<typeof StyledTextLink> {}

const BasicLink = forwardRef<HTMLAnchorElement, StyledTextLinkProps>((props, ref) => {
  return <StyledTextLink {...props} ref={ref} />;
});

const CreatedLink = createLink(BasicLink);

const TextLink: LinkComponent<typeof BasicLink> = (props) => {
  return <CreatedLink {...props} />;
};

export { TextLink, StyledTextLink };
export type { TextLinkProps, StyledTextLinkProps };
